// extracted by mini-css-extract-plugin
module.exports = {"row":"CompanyForm_row__22ID-","shortField":"CompanyForm_shortField__3jK-i"};